import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=581c5c0b&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c5c0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581c5c0b')) {
      api.createRecord('581c5c0b', component.options)
    } else {
      api.reload('581c5c0b', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=581c5c0b&scoped=true&", function () {
      api.rerender('581c5c0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B6wGS5YGi759/JS/comp/Accordion.vue"
export default component.exports